import * as React from "react"
import NoPage from "../components/404_Page/404_Page"

// markup
const NotFoundPage = () => {
  return (
    <NoPage />
  )
}

export default NotFoundPage